/**
 * Display price for buy-now listings.
 *
 * API shapes:
 * - My vehicles / create: `price` = vehicle price, `buy_now_price` = listing amount
 * - GET api/v1/buynow/: often omits `buy_now_price`; listing amount is in
 *   `product_price` while `price` remains the vehicle base price
 */
export function getBuyNowDisplayPrice(item, options = {}) {
  if (!item || typeof item !== "object") return null;

  const buyNowFloor = Boolean(options.buyNowFloor);
  const hasBuyNowPrice = isPresentPrice(item.buy_now_price);
  const onBuyList =
    buyNowFloor ||
    Boolean(item.buy_now) ||
    hasBuyNowPrice ||
    looksLikeBuyNowLot(item);

  if (onBuyList) {
    return firstPrice(
      item.buy_now_price,
      item.product_price,
      item.price,
      item.start_price
    );
  }

  return firstPrice(
    item.price,
    item.product_price,
    item.buy_now_price,
    item.start_price
  );
}

function isPresentPrice(value) {
  if (value == null || value === "") return false;
  const lowered = String(value).trim().toLowerCase();
  return (
    lowered !== "none" &&
    lowered !== "null" &&
    lowered !== "n/a" &&
    lowered !== "-"
  );
}

/** Buynow list rows: listing in product_price, base vehicle price in price. */
function looksLikeBuyNowLot(item) {
  if (!isPresentPrice(item.product_price) || !isPresentPrice(item.price)) {
    return false;
  }
  const auctionLike =
    item.start_price != null ||
    item.auction_id != null ||
    item.end_at != null ||
    item.start_at != null ||
    item.current_bid != null;
  return !auctionLike;
}

function firstPrice(...candidates) {
  for (const value of candidates) {
    if (isPresentPrice(value)) return value;
  }
  return null;
}
